import { z } from "zod";

// Faixas de carteira — bate com a property `cartera_externo` no HubSpot.
export const CARTEIRA_OPTIONS = [
  { value: "ate1milhao", label: "Até R$ 1 milhão" },
  { value: "1a5milhoes", label: "R$ 1 a 5 milhões" },
  { value: "5a20milhoes", label: "R$ 5 a 20 milhões" },
  { value: "20a100milhoes", label: "R$ 20 a 100 milhões" },
  { value: "acima100milhoes", label: "Mais de R$ 100 milhões" },
] as const;

// Form de candidatura ao programa de parceiros (funil perene de aplicação).
export const eventoFormSchema = z.object({
  fullname: z
    .string()
    .min(3, "Informe seu nome completo")
    .refine((v) => v.trim().includes(" "), {
      message: "Informe nome e sobrenome",
    }),
  email: z.string().email("E-mail inválido"),
  phone: z.string().min(14, "Telefone com DDD: (XX) XXXXX-XXXX"),
  carteira_size: z.string().min(1, "Selecione uma faixa"),
  website: z
    .string()
    .optional()
    .transform((v) => v?.trim() ?? "")
    .refine(
      (v) => v === "" || /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i.test(v),
      { message: "Informe um site válido" }
    ),
  motivacao: z.string().min(1, "Conte um pouco sobre sua atuação"),
});

export type EventoFormData = z.infer<typeof eventoFormSchema>;
